import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FaDownload } from "react-icons/fa";
import "./viewDocument.css";
import pdf from "../../Assets/PDF.svg";
import close from "../../Assets/close.svg";
import OpenDocumentModal from "./OpenDocumentModal";
import RejectApplicationModal from "./RejectApplicationModal";
import ConfromationModal from "./ConfromationModal";
import PaymentStatusModal from "./PaymentStatusModal";

const ViewDocument = ({ restaurant, onClose }) => {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isViewDocumentOpen, setIsViewDocumentOpen] = useState(true);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  const handleRejectClick = () => {
    setIsViewDocumentOpen(false);
    setShowRejectModal(true);
  };

  const handleRejectModalClose = () => {
    setShowRejectModal(false);
    setIsViewDocumentOpen(true);
  };

  const handleRejectConfirm = () => {
    setShowRejectModal(false);
    setShowConfirmationModal(true);
  };

  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
    setIsViewDocumentOpen(true);
  };

  const handleNextClick = () => {
    setIsViewDocumentOpen(false);
    setShowPaymentModal(true);
  };

  const handlePaymentModalClose = () => {
    setShowPaymentModal(false);
    setIsViewDocumentOpen(true);
  };

  const handlePaymentReject = () => {
    setShowPaymentModal(false);
    handleRejectClick();
  };

  const handlePaymentApprove = () => {
    setShowPaymentModal(false);
    onClose();
  };

  const documents = [
    {
      label: "Food Licence",
      id:
        restaurant.doclink?.find((doc) => doc.fileType === "foodLicense")
          ?.docData || "",
      fileType: "foodLicense",
      docName:
        restaurant.doclink?.find((doc) => doc.fileType === "foodLicense")
          ?.docName || "",
      uploadUrl: restaurant.doclink?.find(
        (doc) => doc.fileType === "foodLicense"
      )?.uploadUrl,
    },
    {
      label: "Pan Card",
      id:
        restaurant.doclink?.find((doc) => doc.fileType === "panCard")
          ?.docData || "",
      fileType: "panCard",
      docName:
        restaurant.doclink?.find((doc) => doc.fileType === "panCard")
          ?.docName || "",
      uploadUrl: restaurant.doclink?.find((doc) => doc.fileType === "panCard")
        ?.uploadUrl,
    },
    {
      label: "Menu",
      id: "",
      fileType: "menu",
      docName:
        restaurant.doclink?.find((doc) => doc.fileType === "menu")?.docName ||
        "",
      uploadUrl: restaurant.doclink?.find((doc) => doc.fileType === "menu")
        ?.uploadUrl,
    },
    {
      label: "GST Certificate (Optional)",
      id:
        restaurant.doclink?.find((doc) => doc.fileType === "gstCertificate")
          ?.docData || "",
      fileType: "gstCertificate",
      docName:
        restaurant.doclink?.find((doc) => doc.fileType === "gstCertificate")
          ?.docName || "",
      uploadUrl: restaurant.doclink?.find(
        (doc) => doc.fileType === "gstCertificate"
      )?.uploadUrl,
    },
  ];

  const downloadFile = (url, filename) => {
    if (url && filename) {
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
    }
  };

  return (
    <div className="modal-overlay">
      {isViewDocumentOpen && (
        <div className="view-modal-content">
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="" />
          </button>
          <div className="resturantId">
            <span>Restaurant ID #{restaurant._id}</span>
            <FontAwesomeIcon
              icon={faCopy}
              style={{ color: "#718EBF", cursor: "pointer", fontSize: "12px" }}
            />
          </div>
          <div className="modal-header">
            <h2>Preshit Pimple</h2>
            <span className="status-badge">Pending</span>
          </div>
          <p className="modal-date">{formatDate(restaurant.createdAt)}</p>
          <div className="view-modal-form">
            {documents.map((item, index) => {
              // If both docData and docName are missing, do not render this section
              if (!item.id && !item.docName) return null;

              return (
                <div key={index} className="modal-section">
                  <label className="section-label">{item.label}</label>
                  {item.id && (
                    <input value={item.id} readOnly className="section-input" />
                  )}
                  {item.docName && (
                    <div className="file-container">
                      <div className="file-info">
                        <div className="file-icon">
                          <img src={pdf} alt="" />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            marginLeft: "10px",
                          }}>
                          <span
                            style={{
                              color: "#344054",
                              fontSize: "15px",
                              fontWeight: "500",
                            }}>
                            {item.docName}
                          </span>
                          <span
                            style={{
                              color: "#475467",
                              fontSize: "15px",
                              fontWeight: "400",
                            }}>
                            200 KB – 100% uploaded
                          </span>
                        </div>
                      </div>
                      <div className="file-actions">
                        <FaDownload
                          className="icon"
                          style={{ color: "#F8951D" }}
                          onClick={() =>
                            downloadFile(item.uploadUrl, item.docName)
                          }
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          className="icon"
                          style={{ color: "#F8951D" }}
                          onClick={() => {
                            setSelectedDocument(item);
                            setIsViewDocumentOpen(false);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div className="modal-footer">
              <button className="reject-btn" onClick={handleRejectClick}>Reject</button>
              <button className="next-btn" onClick={handleNextClick}>Next</button>
            </div>
          </div>
        </div>
      )}
      {selectedDocument && (
        <OpenDocumentModal
          document={selectedDocument}
          onClose={() => {
            setSelectedDocument(null);
            setIsViewDocumentOpen(true);
          }}
        />
      )}
      {showRejectModal && (
        <RejectApplicationModal
          onClose={handleRejectModalClose}
          onReject={handleRejectConfirm}
          restaurant={restaurant}
        />
      )}
      {showConfirmationModal && (
        <ConfromationModal
          onClose={handleConfirmationClose}
          onConfirm={() => {
            // Handle final rejection logic here
            setShowConfirmationModal(false);
            onClose();
          }}
        />
      )}
      {showPaymentModal && (
        <PaymentStatusModal
          onClose={handlePaymentModalClose}
          onReject={handlePaymentReject}
          onApprove={handlePaymentApprove}
        />
      )}
    </div>
  );
};

export default ViewDocument;
